import { ClassNameProvider } from '@/styles/Countdown';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { CountdownTime, getCountdownTime } from '@/utils/getCountdownTime';
import { ReactNode, useEffect, useState } from 'react';
import { Countdown } from './Countdown';

export interface StandaloneCountdownProps extends StandaloneComponentProps<typeof Countdown> {
  title?: ReactNode;
  endTime?: string;
}

const timestamps = ['Dagar', 'Timmar', 'Minuter', 'Sekunder'];

export const StandaloneCountdown: StandaloneComponent<StandaloneCountdownProps> = ({
  title,
  endTime,
  options,
  ...props
}) => {
  const [leftTime, setLeftTime] = useState<CountdownTime>();

  const { $title, $group, $timestamp: timestampProps, ...$base } = options ?? {};
  const { $label, ...$timestamp } = timestampProps ?? {};

  useEffect(() => {
    const initialTime = getCountdownTime(endTime ?? '');
    setLeftTime(initialTime);

    const intervalId = setInterval(() => {
      const time = getCountdownTime(endTime ?? '');
      setLeftTime(time);

      if (time.totalTime <= 0 || !time.totalTime) {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [endTime]);

  return (
    <ClassNameProvider value={$base}>
      <Countdown {...$base} {...props}>
        <Countdown.Title {...$title}>{title}</Countdown.Title>
        <Countdown.Group {...$group}>
          {timestamps.map((timestamp, timestampIndex) => (
            <Countdown.Timestamp key={timestamp} {...$timestamp}>
              {leftTime?.timestamps[timestampIndex]}
              <Countdown.Timestamp.Label {...$label}>{timestamp}</Countdown.Timestamp.Label>
            </Countdown.Timestamp>
          ))}
        </Countdown.Group>
      </Countdown>
    </ClassNameProvider>
  );
};

export default StandaloneCountdown;
